import * as React from 'react';
import classnames from 'classnames';
import SwipeableViews from 'react-swipeable-views';
import { CarouselNavigationChevron } from './components/CarouselNavigationChevron.js';

const Carousel = ({ children , className , hasNavigation =true , hasPagination =false , hasInverseColor =false , onIndexChange , navigationLocation ='bottom' , shouldLoopNavigationFocus =false , 'data-t': dataT  })=>{
    const [activeIndex, setActiveIndex] = React.useState(0);
    const [hasNavigated, setHasNavigated] = React.useState(false);
    const leftButtonRef = React.useRef(null);
    const rightButtonRef = React.useRef(null);
    const handleIndexChange = React.useCallback((index)=>{
        setActiveIndex(index);
        onIndexChange && onIndexChange(index);
        setHasNavigated(true);
    }, [
        onIndexChange
    ]);
    const setSlide = React.useCallback((index)=>{
        if (index !== activeIndex) {
            setActiveIndex(index);
            handleIndexChange(index);
        }
    }, [
        activeIndex,
        handleIndexChange
    ]);
    const handlePrevClick = React.useCallback((e)=>{
        const newIndex = activeIndex !== 0 ? activeIndex - 1 : children.length;
        handleIndexChange(newIndex);
        e.preventDefault();
    }, [
        activeIndex,
        children.length,
        handleIndexChange
    ]);
    const handleNextClick = React.useCallback((e)=>{
        const newIndex = activeIndex !== children.length - 1 ? activeIndex + 1 : 0;
        handleIndexChange(newIndex);
        e.preventDefault();
    }, [
        activeIndex,
        children.length,
        handleIndexChange
    ]);
    const isFirstSlideActive = activeIndex < 1;
    const isLastSlideActive = activeIndex >= children.length - 1;
    React.useEffect(()=>{
        if (!shouldLoopNavigationFocus || !hasNavigated) return;
        if (isFirstSlideActive) {
            var ref;
            rightButtonRef === null || rightButtonRef === void 0 ? void 0 : (ref = rightButtonRef.current) === null || ref === void 0 ? void 0 : ref.focus();
        } else if (isLastSlideActive) {
            var ref1;
            leftButtonRef === null || leftButtonRef === void 0 ? void 0 : (ref1 = leftButtonRef.current) === null || ref1 === void 0 ? void 0 : ref1.focus();
        }
    }, [
        isFirstSlideActive,
        isLastSlideActive,
        shouldLoopNavigationFocus,
        hasNavigated
    ]);
    if (!children || children.length === 0) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames('carousel', className),
        "data-t": dataT || 'carousel'
    }, /*#__PURE__*/ React.createElement("div", {
        className: classnames('carousel__inner', {
            'carousel__inner-disable': navigationLocation == 'top'
        })
    }, hasNavigation && /*#__PURE__*/ React.createElement(CarouselNavigationChevron, {
        isDisabled: isFirstSlideActive,
        hasInverseColor: hasInverseColor,
        hasTopNavigation: navigationLocation == 'top',
        onClick: handlePrevClick,
        direction: "left",
        ref: leftButtonRef
    }), /*#__PURE__*/ React.createElement(SwipeableViews, {
        className: "carousel__container",
        style: {
            height: '100%'
        },
        onChangeIndex: setSlide,
        enableMouseEvents: true,
        index: activeIndex
    }, children.map((child, i)=>/*#__PURE__*/ React.createElement("div", {
            className: "carousel__item",
            key: `item-${i}`
        }, child)
    )), hasNavigation && /*#__PURE__*/ React.createElement(CarouselNavigationChevron, {
        isDisabled: isLastSlideActive,
        hasInverseColor: hasInverseColor,
        hasTopNavigation: navigationLocation == 'top',
        onClick: handleNextClick,
        direction: "right",
        ref: rightButtonRef
    })), hasPagination && /*#__PURE__*/ React.createElement("div", {
        className: "carousel__pagination"
    }, children.map((_, index)=>/*#__PURE__*/ React.createElement("button", {
            key: index,
            "aria-label": `${index + 1}`,
            className: classnames('carousel__pagination-indicator', {
                _is_active: index === activeIndex
            }),
            onClick: ()=>setSlide(index)
        })
    )));
};

export { Carousel, Carousel as default };
//# sourceMappingURL=Carousel.js.map
